export const HEADER_HEIGHT = 88;
export const TOP_BAR_HEIGHT = 32;
export const FULL_HEADER_HEIGHT = 120;
export const pageType = {
  column: 'MegaMenuColumnPage',
  section: 'MegaMenuSectionPage',
  otherColumn: 'MegaMenuOtherPage',
};

type LangType = {
  code: string;
  value: string;
};

export const formFieldType = {
  quoteitem: "quoteitem",
  textbox: "textbox",
  textboxlist: "textboxlist",
  textarea: "textarea",
  email: "textboxemail",
  phone: 'phonenumber',
  file: "fileupload",
  checkbox: "checkbox",
  radio: "radio",
  toggle: "toggle",
  regionselection: "regionselection",
  industryselection: "industryselection",
  productselection: "productselection",
  applicationselection: "applicationselection",
  optiongroup: "optiongroup",
};
export const langJson: LangType[] = [
  {
    code: 'en', // what episerver has
    value: 'en', // bc7 standared
  },
  {
    code: 'sv',
    value: 'sv',
  },
  {
    code: 'de',
    value: 'de',
  },
  {
    code: 'fr',
    value: 'fr',
  },
  {
    code: 'es',
    value: 'es',
  },
  {
    code: 'no',
    value: 'no',
  },
  {
    code: 'da',
    value: 'da',
  },
  {
    code: 'fi',
    value: 'fi',
  },
  {
    code: 'nl',
    value: 'nl',
  },
  {
    code: 'en-ca',
    value: 'en-ca',
  },
  {
    code: 'fr-ca',
    value: 'fr-ca',
  },
  {
    code: 'pt',
    value: 'pt',
  },
  {
    code: 'ru',
    value: 'ru',
  },
  {
    code: 'it',
    value: 'it',
  },
  {
    code: 'sk',
    value: 'sk',
  },
  {
    code: 'cs',
    value: 'cs',
  },
  {
    code: 'hu',
    value: 'hu',
  },
  {
    code: 'zh',
    value: 'zh',
  },
  {
    code: 'pl',
    value: 'pl',
  },
  {
    code: 'ja',
    value: 'ja',
  },
  {
    code: 'ko',
    value: 'ko',
  },
  {
    code: 'el',
    value: 'el',
  },
  {
    code: 'tr',
    value: 'tr',
  },
  {
    code: 'zh-tw',
    value: 'zh-tw',
  },
  {
    code: 'lv',
    value: 'lv',
  },
  {
    code: 'lt',
    value: 'lt',
  },
  {
    code: 'ro',
    value: 'ro',
  },
  {
    code: 'sl',
    value: 'sl',
  },
  {
    code: 'en-gb',
    value: 'en-gb',
  },
  {
    code: 'he',
    value: 'he',
  },
  {
    code: 'fr-be',
    value: 'fr-be',
  },
  {
    code: 'en-bz',
    value: 'en-bz',
  },
  {
    code: 'es-mx',
    value: 'es-mx',
  },
  {
    code: 'es-ar',
    value: 'es-ar',
  },
  {
    code: 'en-us',
    value: 'en-us',
  },
  {
    code: 'en-au',
    value: 'en-au',
  },
  {
    code: 'en-nz',
    value: 'en-nz',
  },
  {
    code: 'en-sg',
    value: 'en-sg',
  },
  {
    code: 'es-co',
    value: 'es-co',
  },
  {
    code: 'en-in',
    value: 'en-in',
  },
  {
    code: 'en-tt',
    value: 'en-tt',
  },
  {
    code: 'en-za',
    value: 'en-za',
  },
  {
    code: 'uk',
    value: 'uk',
  },
  {
    code: 'en-my',
    value: 'en-my',
  },
  {
    code: 'id',
    value: 'id',
  },
  {
    code: 'th',
    value: 'th',
  },
  {
    code: 'bg',
    value: 'bg',
  },
  {
    code: 'en-fr',
    value: 'en-fr',
  },
];

//Story 365068 - Added to check for the links that contains "shop.alfalaval.com"
export const productShopUrl = "shop.alfalaval.com";